import Http from "@/utils/httpClient";
import { getListTicketsParams } from "./http-params";

const state = () => ({
    current: {
        attachments: [],
        links: [],
        logs: [],
    },
    selectedConversation: {},
    tickets: [],
    isLoading: false,
    reloadCurrent: false,
    meta: {},
    priorities: [],
    departments: [],
    types: [],
    statuses: [],
    descriptionFormats: [],
});

const getters = {
    current: (state) => state.current,
    selectedConversation: (state) => state.selectedConversation,
    tickets: (state) => state.tickets,
    isLoading: (state) => state.isLoading,
    meta: (state) => state.meta,
    priorities: (state) => state.priorities,
    descriptionFormats: (state) => state.descriptionFormats,
    departments: (state) => state.departments,
    types: (state) => state.types,
    statuses: (state) => state.statuses,
    reloadCurrent: (state) => state.reloadCurrent,
};

const mutations = {
    updateCurrent(state, ticket) {
        state.current = Object.assign({}, state.current, ticket);
    },
    updateTickets(state, tickets) {
        state.tickets = tickets;
    },
    updateMeta(state, meta) {
        state.meta = meta;
    },
    updatePriorities(state, priorities) {
        state.priorities = priorities;
    },
    updateDepartments(state, departments) {
        state.departments = departments;
    },
    updateTypes(state, types) {
        state.types = types;
    },
    updateStatuses(state, statuses) {
        state.statuses = statuses;
    },
    updateDescriptionFormats(state, formats) {
        state.descriptionFormats = formats;
    },
    updateIsLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
    updateReloadCurrent(state, reloadCurrent) {
        state.reloadCurrent = reloadCurrent;
    },
    addConversation(state, conversation) {
        state.current.logs.push(conversation);
    },
    selectConversation(state, conversation) {
        state.selectedConversation = conversation;
    },
    updateConversation(state, conversation) {
        const index = state.current.conversations.findIndex((item) => item.id === conversation.id);

        if (index !== -1) {
            state.current.conversations.splice(index, 1, conversation);
        }
    },
    deleteConversation(state, { id, parentId }) {
        if (parentId) {
            const parentIndex = state.current.conversations.findIndex(
                (item) => item.id === parentId
            );
            const index = state.current.conversations[parentIndex].replies.findIndex(
                (item) => item.id === id
            );
            state.current.conversations[parentIndex].replies.splice(index, 1);
            return;
        }

        const index = state.current.conversations.findIndex((item) => item.id === id);

        if (index !== -1) {
            state.current.conversations.splice(index, 1);
        }
    },
    storeConversationReply(state, { id, data }) {
        const index = state.current.logs.findIndex((item) => item.id === id);

        if (index !== -1) {
            const temp = JSON.parse(JSON.stringify(state.current));
            temp.logs[index].children.push(data);

            state.current = temp;
        }
    },
    updateCurrentPriority(state, priority) {
        state.current.priority_id = priority;
    },
    updateTicket(state, { id, props }) {
        const index = state.tickets.findIndex((ticket) => ticket.id === id);

        if (index !== -1) {
            const ticket = Object.assign({}, state.tickets[index], props);

            state.tickets.splice(index, 1, ticket);
        }
    },
};

const actions = {
    softDeleteConversation({ commit }, { id, url, parentId }) {
        return Http.delete(url).then(() => {
            commit("deleteConversation", { id, parentId });
        });
    },
    async loadTickets({ commit }, route) {
        commit("updateIsLoading", true);

        try {
            const { data } = await Http.get("tickets", { params: getListTicketsParams(route) });

            commit("updateTickets", data.data.data ? data.data.data : data.data);
            commit("updateMeta", data.meta);
            commit("updatePriorities", data.priorities);
            commit("updateDepartments", data.departments);
            commit("updateTypes", data.types);
            commit("updateStatuses", data.statuses);
            commit("updateDescriptionFormats", data.description_formats);
        } finally {
            commit("updateIsLoading", false);
        }
    },
    updateTicketPriority(context, { ticketId, priorityId }) {
        Http.patch(`tickets/${ticketId}/priority`, {
            ticket_priority_id: priorityId,
        });
    },
    updateDescriptionFormat(context, { ticketId, formatId }) {
        Http.patch(`tickets/${ticketId}/description-format`, {
            description_format: formatId,
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
